module.exports = __webpack_public_path__ + "img/myanmar.4be9b6d.webp";